import React from 'react';
import WaveDirection from './WaveDirection';
import WaveHeight from './WaveHeight';
import HistoryRow from './HistoryRow';
import ReactGA from 'react-ga';

class Row extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showHistory: false,
      showWindWaveHistory: false,
    };
  
  }

  toggleHistory(event) {
    console.log("toggle swell");
    this.setState({ showHistory: !this.state.showHistory });
    // Log GA event
    let action = this.state.showHistory ? 'Hide swell history' : 'Show swell history';
    ReactGA.event({
      category: 'Interaction',
      action: action,
      label: this.props.data.title
    });
  }

  toggleWindWaveHistory(event) {
    console.log("toggle wind");
    this.setState({ showWindWaveHistory: !this.state.showWindWaveHistory });
    // Log GA event
    let action = this.state.showWindWaveHistory ? 'Hide wind wave history' : 'Show wind wave history';
    ReactGA.event({
      category: 'Interaction',
      action: action,
      label: this.props.data.title
    });
  }

  render() {
    let char = this.state.showHistory ? "-" : "+";
    let windWavechar = this.state.showWindWaveHistory ? "-" : "+";
    let maxAge = 3 * 3600;
    return (
      <tbody>
        <tr>
          <td className="title">{this.props.data.title}</td>
          <td className="direction" data-label="Deining (richting)">
            {this.props.data.wave_direction !== undefined &&
              <WaveDirection data={this.props.data.wave_direction} maxAge={maxAge} />
            }
          </td>
          <td className="height" data-label="Deining (hoogte)">
            {this.props.data.wave_height !== undefined &&
              <WaveHeight data={this.props.data.wave_height} maxAge={maxAge} />
            }
          </td>
          <td className="toggleHistory" data-label="Geschiedenis">
            <button type="button" onClick={ this.toggleHistory.bind(this) }>{char}</button>
          </td>
          <td className="direction" data-label="Windgolven (richting)">
            {this.props.data.wind_wave_direction !== undefined &&
              <WaveDirection data={this.props.data.wind_wave_direction} maxAge={maxAge} />
            }
          </td>
          <td className="height" data-label="Windgolven (hoogte)">
            {this.props.data.wind_wave_height !== undefined &&
              <WaveHeight data={this.props.data.wind_wave_height} maxAge={maxAge} />
            }
          </td>
          <td className="toggleHistory" data-label="Geschiedenis">
            <button type="button" onClick={ this.toggleWindWaveHistory.bind(this) }>{windWavechar}</button>
          </td>
        </tr>
        {this.state.showHistory &&
        <tr>
          <td colSpan="7">
            <HistoryRow code={this.props.data.code} param="wave_height" title={ "Deining " + this.props.data.title } />
          </td>
        </tr>
        }
        {this.state.showWindWaveHistory &&
        <tr>
          <td colSpan="7">
            <HistoryRow code={this.props.data.code} param="wind_wave_height" title={ "Wind Waves " + this.props.data.title } />
          </td>
        </tr>
        }
      </tbody>);
  }

}

export default Row;



// WEBPACK FOOTER //
// ./src/Components/Row.jsx